import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogData } from './generic-dialog';

@Component({
  selector: 'generic-dialog',
  templateUrl: './generic-dialog.component.html',
  styleUrls: ['./generic-dialog.component.scss']
})
export class GenericDialogComponent implements OnInit {
  public genericDialogData = new GenericDialogData();
  @ViewChild('wrapper',{static:false}) public wrapper;

  constructor(
    private dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: GenericDialogData
  ) {
    if (data) {
      this.genericDialogData = data;
    }
  }

  /**
   * ng hook
   */
  public ngOnInit(): void {
    this.wrapper.nativeElement.parentElement.parentElement.style.overflow = 'visible';
  }

  /**
   * Close the dialog with the button index dialog button is clicked
   * @param index
   */
  public buttonClicked(index): void {
    this.dialogRef.close(index);
  }

  /**
   * Back link clicked
   */
  public backClick(): void {
    this.dialogRef.close(null);
  }
}
